import loadScript from 'load-scripts';

import { PLACES_API_COUNTRY, PLACES_LIBRARY_URL, PLACES_TYPES } from '../config';
import { type FetchPredictions } from './fetch-predictions.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Fetches autocomplete predictions using Google Places Autocomplete API.
 */
export const fetchPredictions: FetchPredictions = async (props) => {
  const { input, apiKey, placesTypes = [PLACES_TYPES.ADDRESS] } = props;

  const placesAPI = window.google?.maps?.places;

  if (!placesAPI) {
    await loadScript(`${PLACES_LIBRARY_URL}&key=${apiKey}`);
  }

  const service = new window.google.maps.places.AutocompleteService();

  /**
   * @see {@link https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest}
   */
  const config = {
    input,
    types: placesTypes,
    componentRestrictions: { country: PLACES_API_COUNTRY },
  };
  const data = await service.getPlacePredictions(config);

  return data ?? { predictions: [] };
};
